import { debounce, get } from "lodash";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { language } from "~/libs/getData";
import {
  DealerStatus,
  useGetDealersLazyQuery,
} from "~/schemas/generated/graphql";

export const onScrollBottomDealers = (activeSearch?: string) => {
  const { t } = useTranslation();
  const isEn = language === "en";

  const [GetDealersForSelectQuery, { data, loading, fetchMore }] =
    useGetDealersLazyQuery({
      variables: activeSearch
        ? {
            count: 25,
            page: 0,
            search: {
              SearchFields: ["status"],
              status: activeSearch,
            },
          }
        : {
            count: 25,
            page: 0,
          },
      fetchPolicy: "cache-and-network",
      notifyOnNetworkStatusChange: true,
    });

  useEffect(() => {
    GetDealersForSelectQuery();
  }, []);

  const dealersForSelect = [
    ...get(data, "DealerGetter.getDealers.items", []).map(
      ({ id, DealerName, DealerNameEn }) => {
        return {
          value: id,
          label: isEn ? DealerNameEn : DealerName,
        };
      },
    ),
  ];

  const introspectionHandler = () => {
    if (dealersForSelect.length < 25) {
      return;
    }
    const page = Math.ceil(dealersForSelect.length / 25);
    fetchMore({
      variables: {
        page,
      },
      updateQuery: ({ DealerGetter }, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return { DealerGetter };
        }
        return {
          DealerGetter: {
            ...DealerGetter,
            getDealers: {
              ...DealerGetter.getDealers,
              items: [
                ...DealerGetter.getDealers.items,
                ...get(fetchMoreResult, "DealerGetter.getDealers.items", []),
              ],
            },
          },
        };
      },
    });
  };

  const searchDealerFilterStatus = ({ searchText, status }) => {
    if (!activeSearch) {
      return isEn
        ? { SearchFields: ["DealerNameEn"], DealerNameEn: searchText }
        : { SearchFields: ["DealerName"], DealerName: searchText };
    }
    return isEn
      ? {
          SearchFields: ["DealerNameEn", "status"],
          DealerNameEn: searchText,
          status: status,
        }
      : {
          SearchFields: ["DealerName", "status"],
          DealerName: searchText,
          status: status,
        };
  };
  const searchDealer = debounce((searchText: string) => {
    GetDealersForSelectQuery({
      variables: searchText
        ? {
            page: 0,
            search: searchDealerFilterStatus({
              searchText,
              status: DealerStatus.Active,
            }),
          }
        : {
            count: 25,
            page: 0,
            ...(activeSearch
              ? { search: { SearchFields: ["status"], status: activeSearch } }
              : {}),
          },
    });
  });

  return {
    dealersForSelect,
    introspectionHandler,
    searchDealer,
    GetViolationTypesLoading: !!loading,
  };
};
